import React from 'react';

const QuestionCard = ({ 
  question, 
  onOptionSelect, 
  userAnswer, 
  showAnswer = false,
  currentQuestion,
  totalQuestions 
}) => {
  const isAnswered = userAnswer !== null;
  const isCorrect = isAnswered && userAnswer === question.answerIndex;

  return (
    <div className="question-card">
      <div className="progress-bar">
        <div 
          className="progress-fill"
          style={{ width: `${((currentQuestion + 1) / totalQuestions) * 100}%` }}
        ></div>
      </div>
      
      <div className="question-header">
        <span className="question-number">Question {currentQuestion + 1} of {totalQuestions}</span>
        {isAnswered && (
          <span className={`question-status ${isCorrect ? 'correct' : 'incorrect'}`}>
            {isCorrect ? '✓ Correct' : '✗ Incorrect'}
          </span>
        )}
      </div>

      <h3 className="question-text">{question.text}</h3>

      {question.img && (
        <div className="question-image">
          <img 
            src={question.img} 
            alt="Question visual" 
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </div>
      )}

      <div className="options-container">
        {question.options.map((option, index) => (
          <button
            key={index}
            className={`option-button ${
              userAnswer === index ? (isCorrect ? 'selected-correct' : 'selected-incorrect') : ''
            } ${
              showAnswer && index === question.answerIndex && userAnswer !== index 
                ? 'correct-answer' 
                : ''
            } ${
              isAnswered ? 'disabled' : ''
            }`}
            onClick={() => !isAnswered && onOptionSelect(index)}
            disabled={isAnswered}
          >
            <span className="option-letter">
              {String.fromCharCode(65 + index)}
            </span>
            <span className="option-text">{option}</span>
            {userAnswer === index && <span className="selected-icon">✓</span>}
            {showAnswer && index === question.answerIndex && userAnswer !== index && (
              <span className="correct-icon">✓</span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuestionCard;
